import { observer } from 'mobx-react';
import { FC, ReactElement, useEffect } from 'react';
import { Prompt } from 'react-router';
import { PreparationSettingMain } from './containers/PreparationSettingMain/PreparationSettingMain';
import { PreparationSettingProfileBranches } from './containers/PreparationSettingProfileBranches/PreparationSettingProfileBranches';
import { PreparationSettingProfiles } from './containers/PreparationSettingProfiles/PreparationSettingProfiles';
import preparationProfilesStore from './store/preparationProfilesStore';
import { SCREENS } from 'src/constants/screens';
import HeaderBack from 'src/view/containers/Headers/components/HeaderBack/HeaderBack';
import Headers from 'src/view/containers/Headers/Headers';
import { getPromptProps } from '~/view/components/CustomPrompt/helper';
import LoadingOverlay from '~/view/components/LoadingOverlay/LoadingOverlay';

const PreparationProfilesSettingsScreen: FC = observer((): ReactElement => {
  useEffect(() => {
    preparationProfilesStore.init();
  }, []);

  return (
    <div className="d-flex flex-column full-width">
      <Headers>
        <HeaderBack title="preparation_settings_and_profiles" path={SCREENS.SETTINGS()} />
      </Headers>

      <div className="d-flex flex-1 mt-6">
        <PreparationSettingProfiles />
        <PreparationSettingProfileBranches />
        <PreparationSettingMain />
      </div>

      <LoadingOverlay visible={preparationProfilesStore.isLoading} refreshing />
      <Prompt when={preparationProfilesStore.isEdit} message={getPromptProps()} />
    </div>
  );
});

export default PreparationProfilesSettingsScreen;
